import "./assets/style.scss";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import AZ from "./pages/A-Z";
import Activity from "./pages/Activity";
import Checkin from "./pages/Checkin";
import Dashboard from "./pages/Dashboard";
import Layout from "./components/Layout";
import Places from "./pages/Places";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/az" element={<AZ />} />
          <Route path="/places" element={<Places />} />
          <Route path="/activity" element={<Activity />} />
          <Route path="/checkin" element={<Checkin />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
